import { mergeObjectTypes } from '../cacheHelpers';

const CargoDimensionsType = {
  merge: mergeObjectTypes
};

export default CargoDimensionsType;
